// import createPersistedState from 'vuex-persistedstate'
import store from '@/store'
import router from '@/router'
import * as apiCommon from '@/api/common'
import * as apiNews from '@/api/news'
import * as _ from 'lodash'
import { breakComma, formatDate } from '@/util/common'

const getDefaultState = () => {
  const defaults = {
    lists: [],
    lists_sp: [],
    isListsLoaded: false,
    canload: true,
    search: {
      start: 0,
      per_page: 30,
      is_paginate: 0,
      filterCategories: [],
      filterClassifications: []
    },
    isSearching: false,
    pagenation: {
      count: null,
      currentPage: 1
    },
    categories: [], // お知らせカテゴリ
    classifications: [], // お知らせ重要度
    detail_data: {
      publication_day: '',
      classification_name: '',
      category_name: '',
      title: '',
      detail: '',
      classification: 0
    },
    numberCarouselVisible: 0 // 表示中のカルーセルのスライド番号(SP用)
  }
  return defaults
}

const news = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    countLists: (state) => {
      const string = _.isNumber(state.pagenation.count)
        ? breakComma(state.pagenation.count)
        : ''
      return string
    }
  },
  mutations: {
    setLists: (state, lists) => {
      state.lists = lists

      // SPページ表示用リストを生成
      let prePublicationDay = ''
      const listsSP = []
      for (let i = 0; i < lists.length; i++) {
        if (lists[i].publication_day !== prePublicationDay) {
          const map = {
            publication_day: lists[i].publication_day,
            lists: [lists[i]]
          }
          listsSP.push(map)
        } else {
          const lastIndex = listsSP.length - 1
          listsSP[lastIndex].lists.push(lists[i])
        }
        prePublicationDay = lists[i].publication_day
      }
      state.lists_sp = listsSP

      state.isListsLoaded = true
    },
    setIsListsLoaded: (state, isListsLoaded) => {
      state.isListsLoaded = isListsLoaded
    },
    setStart: (state, num) => {
      state.search.start = num
    },
    setPerPage: (state, num) => {
      state.search.per_page = num
    },
    setCanload: (state, boolean) => {
      state.canload = boolean
    },
    resetLists: (state) => {
      state.lists.splice(0, state.lists.length)
      state.lists_sp.splice(0, state.lists_sp.length)
    },
    setFilterCategories: (state, categories) => {
      state.search.filterCategories = categories
    },
    setFilterClassifications: (state, classifications) => {
      state.search.filterClassifications = classifications
    },
    listSearchStart(state) {
      state.isSearching = true
    },
    listSearchEnd(state) {
      state.isSearching = false
    },
    setCount(state, count) {
      state.pagenation.count = count
    },
    setPageNation(state, { currentPage, start }) {
      state.pagenation.currentPage = currentPage
      state.search.start = start
      state.search.is_paginate = 1
    },
    resetPageNation(state) {
      const { search, pagenation } = getDefaultState()
      state.search.start = search.start
      state.search.is_paginate = search.is_paginate
      state.pagenation.count = pagenation.count
      state.pagenation.currentPage = pagenation.currentPage
    },
    setNumberCarouselVisible(state, numberCarouselVisible) {
      state.numberCarouselVisible = numberCarouselVisible
    }
  },
  actions: {
    setFilterCategories: async ({ commit, dispatch }, categories) => {
      commit('setFilterCategories', categories)
      commit('resetLists')
      commit('setStart', 0)
      dispatch('getLists')
      dispatch('resetPagenation')
    },
    setFilterClassifications: async ({ commit, dispatch }, classifications) => {
      commit('setFilterClassifications', classifications)
      commit('resetLists')
      commit('setStart', 0)
      dispatch('getLists')
      dispatch('resetPagenation')
    },
    getLists: async ({ commit, state, dispatch }) => {

      commit('listSearchStart')
      const params = {
        start: state.search.start,
        per_page: state.search.per_page,
        category: state.search.filterCategories,
        classification: state.search.filterClassifications
      }
      commit('setPerPage', params.per_page)
      if (state.canload) {
        commit('setCanload', false)
        const res = await apiNews
          .list(params)
          .then(async(response) => {
            const { data } = response
            if (data.status === 0) {
              const { list } = data

              if (list && list.length > 0) {
                await commit('setLists', list)
                commit('setCanload', true)
              } else {
                commit('setCanload', true)
              }
              commit('setCount', data.search_count)
            }
            return data
          })
          .finally(() => {
            store.dispatch('news/setIsListsLoaded', true)
            commit('listSearchEnd')
          })
        return res
      }
    },
    resetLists: ({ commit, state }) => {
      if (state.canload) {
        commit('resetLists')
      }
    },
    setIsListsLoaded: ({ commit }, isListsLoaded) => {
      commit('setIsListsLoaded', isListsLoaded)
    },
    getTypes({ state }) {
      const masterParams = {}

      masterParams.key = 'news_category'
      apiCommon.fetchMaster(masterParams)
        .then(response => {
          if (response) {
            const { data } = response
            if (data) {
              const status = data.status ?? -1
              if (status === 0) {
                state.categories = data.list
              } else {
                store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
              }
            }
          }
        })

      masterParams.key = 'news_importance'
      apiCommon.fetchMaster(masterParams)
        .then(response => {
          if (response) {
            const { data } = response
            if (data) {
              const status = data.status ?? -1
              if (status === 0) {
                state.classifications = data.list
              } else {
                store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
              }
            }
          }
        })
    },
    async setPagenation({ commit }, payload) {
      await commit('setPageNation', payload)
    },
    async resetPagenation({ commit }) {
      await commit('resetPageNation')
    },

    async getDetail({state}, id) {
      if (id >= 0) {

        // お知らせ詳細APIをコール
        const params = {}
        params.id = id
        await apiNews.detail(params)
          .then(response => {
            if (response) {
              const { data } = response
              if (data) {

                const status = data.status ?? -1

                if (status === 0) {
                  // status=0: 成功
                  state.detail_data.publication_day = formatDate(data.publication_day)
                  state.detail_data.classification_name = data.classification_name
                  state.detail_data.classification = data.classification
                  state.detail_data.category_name = data.category_name
                  state.detail_data.title = data.title
                  state.detail_data.detail = data.detail
                } else {
                  // status=その他: エラーダイアログを表示
                  store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
                }
              }
            }
          })
      } else {
        // リロード時は一覧に戻す
        router.push({ path: '/pc/information-list' })
      }
    },
    // 表示中のカルーセルのスライド番号(SP用)
    setNumberCarouselVisible({ commit }, numberCarouselVisible) {
      commit('setNumberCarouselVisible', numberCarouselVisible)
    }
  }
}

export default news
